import { createApp } from 'vue'
import App from './App.vue'

import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';
import back from './components/icon/back'

// Sync store with router
sync(store, router)

const app = createApp(App)
app.use(router)
app.use(store)
app.use(vuetify)
app.component('back', back)
app.mount('#app')

// Vue.component('back', back)

// new Vue({
//   sync,
//   router,
//   store,
//   vuetify,
//   render: createElement => createElement(App)
// }).$mount('#app')
